import {ArrowDirectionType, ArrowLineType} from '../constants/dataEnum';

export const zeroOffset = {x: 0, y: 0};

// get the midpoint position of an element
export const getCenterPosition = (rawPos, customYVal) => ({
  x: (rawPos.left + rawPos.right) / 2,
  y: customYVal || rawPos.y + rawPos.height / 2,
});

const mapArrowDefinitionsOptions = {
  sourceOffset: zeroOffset,
  destinationOffset: zeroOffset,
  line: ArrowLineType.BOW,
  gap: 0,
  otherProps: {},
  isPositionOnCenter: false,
};

export const mapArrowDefinitions = (sourcePositionRaw, destinationPositionRaw, opt = mapArrowDefinitionsOptions) => {
  if (!sourcePositionRaw || !destinationPositionRaw) return {};

  const {sourceOffset, destinationOffset, line, gap, otherProps, isPositionOnCenter} = {
    ...mapArrowDefinitionsOptions,
    ...(opt || {}),
  };

  const sourcePosition = isPositionOnCenter ? getCenterPosition(sourcePositionRaw) : sourcePositionRaw;
  const destinationPosition = isPositionOnCenter ? getCenterPosition(destinationPositionRaw) : destinationPositionRaw;

  const distanceToEdge = Math.abs(window.innerHeight - (sourcePosition.y + destinationOffset.y) - 17);
  const fromX = sourcePosition.x + sourceOffset.x + gap;
  const direction = destinationPosition.x > sourcePosition.x ? ArrowDirectionType.RIGHT : ArrowDirectionType.LEFT;
  const additionalProps =
    line === ArrowLineType.EDGED
      ? {distanceToEdge, ...otherProps}
      : {isCurvedUpwards: true, isRelative: true, ...otherProps};

  return {
    fromX,
    fromY: sourcePosition.y + sourceOffset.y,
    toX: destinationPosition.x + destinationOffset.x,
    toY: destinationPosition.y + destinationOffset.y,
    line,
    direction,
    ...additionalProps,
  };
};
